export default __webpack_public_path__ + "static/media/456.03aff5e3.jpg";